<template>
  <div class="loadingDiv">
    <van-loading size="24px" vertical type="spinner">正在支付中，请勿操作...</van-loading>
  </div>
</template>

<script>
import { findOrder } from '@/api/api.js'
import { Toast } from 'vant'
export default {
  components: {},
  props: {},
  data () {
    return {
      timeFlag: '',
      index: 0
    }
  },
  computed: {},
  methods: {
    async setTimeFn (order) {
      const that = this
      if (that.index < 6) {
        const { data: resss } = await findOrder({
          payId: order
        })
        if (!resss[0]) return Toast('支付失败')
        if (resss[0] && resss[0].result) {
          that.index++
          that.timeFlag = resss[0].result
          if (that.timeFlag === 'SUCCESS') {
            this.$router.push({ name: 'Purchase', params: { type: 'procurement' } })
            Toast.success('支付成功')
          } else {
            that.setTimeFn(this.$store.state.order)
          }
        }
      } else {
        this.$store.commit('setFlag', 'false')
        this.$router.push({ name: 'Purchase', params: { type: 'procurement' } })
        Toast('校验超时')
      }
    }
  },
  beforeCreate () {},
  created () {
    const order = this.$store.state.order
    this.setTimeFn(order)
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .loadingDiv {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%)
  }
</style>
